import '@firebase/database';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/database/dist/index.esm.js
// module id = 281
// module chunks = 1